import { PageHeader } from '../../components/Common';
import { useAuth } from '../../auth/AuthContext';

export function AccountPage() {
  const { user, isOwner } = useAuth();

  if (!user) return null;

  return (
    <>
      <PageHeader
        title="My profile"
        description="Account identity and the business access associated with this sign-in."
      />

      <section className="sf-card sf-card-pad mb-3" aria-labelledby="profile-details">
        <h2 className="sf-section-title" id="profile-details">Account details</h2>
        <dl className="row mb-0">
          <dt className="col-sm-4">Name</dt>
          <dd className="col-sm-8">{user.fullName}</dd>
          <dt className="col-sm-4">Email</dt>
          <dd className="col-sm-8">{user.email || 'Not provided'}</dd>
          <dt className="col-sm-4">Phone</dt>
          <dd className="col-sm-8">{user.phone || 'Not provided'}</dd>
          <dt className="col-sm-4">Account type</dt>
          <dd className="col-sm-8">{isOwner ? 'Business owner' : 'Branch staff'}</dd>
        </dl>
      </section>

      <section className="sf-card sf-card-pad" aria-labelledby="business-access">
        <h2 className="sf-section-title" id="business-access">
          {isOwner ? 'My businesses' : 'Staff association'}
        </h2>
        {user.businesses.length === 0 ? (
          <p className="sf-muted mb-0">No active business association is available.</p>
        ) : (
          user.businesses.map((business) => (
            <div className="border-top pt-3 mt-3" key={business.businessId}>
              <h3 className="h6">{business.businessName}</h3>
              <p className="small mb-2">
                {isOwner ? 'Owner' : 'Staff'} · {business.role}
              </p>
              {!isOwner && (
                <>
                  <p className="small mb-2">
                    HomeRental management:{' '}
                    {business.canManageProperties &&
                    business.categories.includes('HomeRental')
                      ? 'Enabled'
                      : 'Not enabled'}
                  </p>
                  <div className="small fw-semibold">Assigned branches</div>
                  {business.assignedBranches.length === 0 ? (
                    <p className="sf-muted small mb-0">No active branch assignments.</p>
                  ) : (
                    <ul className="small mb-0">
                      {business.assignedBranches.map((branch) => (
                        <li key={branch.propertyId}>{branch.name}</li>
                      ))}
                    </ul>
                  )}
                </>
              )}
              {isOwner && (
                <p className="small sf-muted mb-0">
                  Categories: {business.categories.join(', ') || 'None'}
                </p>
              )}
            </div>
          ))
        )}
      </section>
    </>
  );
}
